<template>

    <!--seccion top-->
    <div class="row mt-4 morado height50 hidden-xs">
        <div class="avance-wrap mt-2 ">
            <div class="avance-circulo activo"><h4>1</h4><div class="avance-circulo-interno"></div></div>
            <div class="avance-linea"></div>
            <div class="avance-circulo"><h4>2</h4><div class="avance-circulo-interno"></div></div>
            <div class="avance-linea"></div>
            <div class="avance-circulo"><h4>3</h4><div class="avance-circulo-interno"></div></div>
            <div class="avance-linea"></div>
            <div class="avance-circulo"><h4>4</h4><div class="avance-circulo-interno"></div></div>
            <div class="avance-linea"></div>
            <div class="avance-circulo"><h4>5</h4><div class="avance-circulo-interno"></div></div>
            <div class="avance-linea"></div>
            <div class="avance-circulo"><h4>6</h4><div class="avance-circulo-interno"></div></div>
            <div class="avance-linea"></div>
            <div class="avance-circulo"><h4>7</h4><div class="avance-circulo-interno"></div></div>
            <div class="avance-linea"></div>
            <div class="avance-circulo"><h4>8</h4><div class="avance-circulo-interno"></div></div>
            <div class="avance-linea"></div>  
                                                  
        </div>                                          
    </div>
    <!--fin seccion top-->


</template>

<script>
export default {
  name: 'Steps'
}
</script>

<style scoped>
.morado{
    background-color: #5A287F;
}
.height50{
   height: 50px; 
}
.avance-circulo.activo{
    background-color: #94C11F;
    border-style: solid;
    border-width: 1px;
    border-color:#94C11F;
}

.avance-circulo{
    color: #94C11F;
    border-style: solid;
    border-width: 1px;
    border-color:#94C11F;
}

  @media (max-width: 768px) {
  .hidden-xs {
    display: none !important;
  }
}

</style>



